/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchTaskAssignment
 */
export interface BatchTaskAssignment {
    /**
     * 
     * @type {number}
     * @memberof BatchTaskAssignment
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BatchTaskAssignment
     */
    privateIpAddress?: string;
}

/**
 * Check if a given object implements the BatchTaskAssignment interface.
 */
export function instanceOfBatchTaskAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function BatchTaskAssignmentFromJSON(json: any): BatchTaskAssignment {
    return BatchTaskAssignmentFromJSONTyped(json, false);
}

export function BatchTaskAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchTaskAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'privateIpAddress': !exists(json, 'private_ip_address') ? undefined : json['private_ip_address'],
    };
}

export function BatchTaskAssignmentToJSON(value?: BatchTaskAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'private_ip_address': value.privateIpAddress,
    };
}

